import { useState } from 'react';
import {
    FormControl,
    Stack,
    FormLabel,
    Box,
    Text,
    ButtonGroup,
} from '@chakra-ui/react';
import { Button } from '@/components/v4';
import { Field } from 'formik';
import NumberField from 'components/forms/new/formikFormFields/NumberField';
import { usePartnerForm } from '../../hooks/usePartnerForm';
import FieldToolTip from 'components/forms/new/FieldToolTip';
import { formLabelStyling } from 'components/forms/new/formStyles';
import { FORM_FIELD_PATHS } from '../../constants';
import {
    stackSpacing,
    stackStyling,
    descriptionStyling,
} from 'components/forms/new/formStyles';

const Surcharge = ({ darkMode, errors }) => {
    const [isHovered, setIsHovered] = useState(false);
    const { formData, updateFormData } = usePartnerForm();
    const hasError = !!errors?.surcharge || !!errors?.surchargeType;

    // Switch logic for SurchargeType
    const handleTypeChange = (type) => {
        updateFormData(FORM_FIELD_PATHS.SURCHARGE_TYPE, type);
    };

    const handleSurchargeChange = (e) => {
        updateFormData(FORM_FIELD_PATHS.SURCHARGE, e.target.value);
    };

    return (
        <FormControl
            sx={{ margin: '0 !important' }}
            isInvalid={hasError}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}>
            <Stack
                direction="row"
                spacing={stackSpacing}
                sx={stackStyling(true)}
                alignItems="center">
                <Box>
                    <FormLabel sx={formLabelStyling(darkMode, true)}>
                        Surcharge
                    </FormLabel>
                    {formData?.partnerBillingSettings?.surchargeType === 1 && (
                        <Text sx={descriptionStyling} maxWidth={250}>
                            The value should be entered as an actual percentage
                            value, eg: 15.4
                        </Text>
                    )}
                </Box>
                <Box
                    display="flex"
                    alignItems="center"
                    flex={1}
                    maxWidth="400px">
                    <Field
                        component={NumberField}
                        id="surcharge"
                        noPadding
                        name="surcharge"
                        displayPrefix={
                            formData?.partnerBillingSettings?.surchargeType ===
                            0
                                ? ' '
                                : '%'
                        }
                        value={formData?.partnerBillingSettings?.surcharge}
                        onChange={handleSurchargeChange}
                        type="number"
                        width="230px"
                    />
                    <ButtonGroup ml={4} isAttached size="sm">
                        <Button
                            sx={{ height: '30px' }}
                            variant={
                                formData?.partnerBillingSettings
                                    ?.surchargeType === 0
                                    ? 'solid'
                                    : 'outline'
                            }
                            onClick={() => handleTypeChange(0)}>
                            Fixed
                        </Button>
                        <Button
                            sx={{ height: '30px', w: '94px' }}
                            variant={
                                formData?.partnerBillingSettings
                                    ?.surchargeType === 1
                                    ? 'solid'
                                    : 'outline'
                            }
                            onClick={() => handleTypeChange(1)}>
                            Percentage
                        </Button>
                    </ButtonGroup>
                    {isHovered && (
                        <FieldToolTip
                            label="Enter surcharge amount and select type for this partner"
                            ariaLabel="surcharge-tip"
                            left="25px"
                        />
                    )}
                </Box>
            </Stack>
        </FormControl>
    );
};

export default Surcharge;
